import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import $ from "jquery";
import Patient from "./Patients";
import ProviderAdvice from "./ProviderAdvice";
import JeevaIntegration from "./PainDataSchedule";
import ViewPatientData from "./ViewPatientData";
import Episode from "./PainDataSchedule";
import PatientJournal from "./PatientJournal";
import PatientSurvey from "./PatientSurvey";
import PatientSuveryResult from "./PatientSuveryResult";
import PatientJournalResult from "./PatientJournalResult";
import PatientMedication from "./PatientMedication";
import MedicationDaysOfWeek from "./MedicationDaysOfWeek";
import MedicationTimeOfDay from "./MedicationTimeOfDay";
import ErrorBoundary from "../../ErrorBoundary";
import ScheduleMileStone from "./ScheduleMileStone";
import PatientAppUsage from "./PatientAppUsage";

class ManageTabSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      hideBotStore: false,
      isActive: this.props.isActive,
      isSafari: false,
    };
  }

  componentDidMount() {
    const browser = navigator.userAgent;
    if (browser.includes("Safari") && !browser.includes("Chrome")) {
      this.state.isSafari = true;
      this.setState(this.state);
    }
    console.log("The browser name is : " + browser);
    if (!this.tabClickHandlerDefined) {
      this.tabClickHandlerDefined = true;
      $(
        "#viewPainData,#episodes,#medication-list,#viewSurvey,#patientJournal,#treatmentMilestone,#patientAppUsage"
      ).on("click", function () {
        $(
          "#viewPainData,#episodes,#medication-list,#viewSurvey,#patientJournal,#treatmentMilestone,#patientAppUsage"
        ).removeClass("active");
        localStorage.setItem("last-project-manage-tab", $(this)[0].id);
        $(this).addClass("active");
      });

      $("#episodes").on("click", function () {
        $("#jeevaInteraction,#hcahps-survey").removeClass("active");
        $("#jeevaInteraction").addClass("active");
      });
    }

    // this.markActiveTab();
  }

  // this function is not used anywhere in this component just reference for future.

  markActiveTab() {
    var currentPath = window.location.href;
    var path =
      window.origin +
      "/my-jeeva/projectmgmt/patient-admission/manage-admission";
    var path1 =
      window.origin +
      "/my-jeeva/projectmgmt/patient-admission/manage-admission/";

    var defaultSelection = false;
    var savedTabSelection = localStorage.getItem("last-project-manage-tab");

    if (savedTabSelection === "episodes") {
      $("#" + savedTabSelection).addClass("active");
    } else if (currentPath == path || currentPath == path1) {
      $("#episodes").addClass("active");
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-data"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-data/"
      )
    ) {
      $("#viewPainData").addClass("active");
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/medication-list"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/medication-list/"
      )
    ) {
      $("#medication-list").addClass("active");
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-survey"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-survey/"
      )
    ) {
      $("#viewSurvey").addClass("active");
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-journal"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-journal/"
      )
    ) {
      $("#patientJournal").addClass("active");
    }
    else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/patient-app-usage"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/patient-app-usage/"
      )
    ) {
      $("#patientAppUsage").addClass("active");
    } else {
      $("#" + savedTabSelection).addClass("active");
    }

    if (defaultSelection !== false) {
      $("#" + defaultSelection).addClass("active");
      localStorage.setItem("last-project-manage-tab", defaultSelection);
    }
  }

  paintTabs() {
    var currentPath = window.location.href;

    var path =
      window.origin +
      "/my-jeeva/projectmgmt/patient-admission/manage-admission";
    var path1 =
      window.origin +
      "/my-jeeva/projectmgmt/patient-admission/manage-admission/";

    if (currentPath == path || currentPath == path1) {
      // return "schedule";
      return "milestone";
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-data"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-data/"
      )
    ) {
      return "episode";
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-survey"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-survey/"
      )
    ) {
      return "survey";
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-journal"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/view-patient-journal/"
      )
    ) {
      return "journal";
    } else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/medication-list"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/medication-list/"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/days-of-week"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/days-of-week/"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/time-of-day"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/time-of-day/"
      )
    ) {
      return "medication";
    }
    else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/treatment-journal"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/treatment-journal/"
      )
    ) {
      {
        return "treatmentMilestone";
      }
    }
    else if (
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/patient-app-usage"
      ) ||
      currentPath.includes(
        "/projectmgmt/patient-admission/manage-admission/patient-app-usage/"
      )
    ) {
      return "appUsage";
    }
  }



  render() {
    let activeTab = this.paintTabs();
    return (
      <ErrorBoundary>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
            <link
              rel="shortcut icon"
              type="image/png"
              href="assets/images/bot.ico"
            />
            <title> Dheeyantra | Clusters Details</title>
            <link
              rel="stylesheet"
              href="plugins/font-awesome/css/font-awesome.min.css"
            />
            <link
              rel="stylesheet"
              href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
            />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link
              href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
              rel="stylesheet"
            />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />

            <div className="content-header">
              <div className="container-fluid">
                <div className={`row ${this.state.isSafari ? "row-safari" : ""}`}
                >
                  <div className="col-sm-5">
                    {/* <h1 className="m-0 page-title">Patient Data</h1> */}
                    <div className="patient-info-container" style={{ width: "53vw" }}>
                      <div className="patient-info-box">
                        <strong>Patient Name</strong>
                        <p>{localStorage.getItem("patientName")}</p>
                      </div>
                      <div className="patient-info-box">
                        <strong>Treatment Name</strong>
                        {window.location.href.includes("/projectmgmt/patient-admission/manage-admission/patient-app-usage") ?
                          <p>Patient app uses all treatments</p>
                          :
                          <p>{localStorage.getItem("procedureName")}</p>
                        }

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="border-bottom"></div>
              <div className="tab-class">
                <ul className={`${this.state.isSafari ? "nav-tabs-safari" : "nav"} nav-tabs border-bottom navCluster`}>
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt/patient-admission/manage-admission"
                    style={{
                      textDecoration: "none",
                      marginLeft: "3vw",
                      marginRight: "3vw",
                    }}
                  >
                    <li
                      className={`nav-link ${activeTab == "milestone" ? "active" : ""
                        }`}
                      id="treatmentMilestone"
                      style={{ marginRight: "15px" }}
                      onClick={() => this.props.onActiveClick("treatmentMilestone")}
                    >
                      Patient Milestone
                    </li>
                  </Link>

                  {/* <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt/patient-admission/manage-admission/episode"
                    style={{
                      textDecoration: "none",
                      marginLeft: "3vw",
                      marginRight: "3vw",
                    }}
                  >
                    <li
                      className={`nav-link ${activeTab == "schedule" ? "active" : ""
                        }`}
                      //className="nav-link"
                      id="episodes"
                      style={{ marginLeft: "-2vw" }}
                      onClick={() => this.props.onActiveClick("schedule")}
                    >
                      Schedule Episodes
                    </li>
                  </Link> */}
                  {/* <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/patient-admission/manage-admission/view-patient-data"
                  style={{
                    textDecoration: "none",
                    marginLeft: "3vw",
                    marginRight: "3vw",
                  }}
                >
                  <li
                    className={`nav-link ${activeTab == "episode" ? "active" : ""
                      }`}
                    // className="nav-link"
                    id="viewPainData"
                    style={{ marginRight: "15px" }}
                    onClick={() => this.props.onActiveClick("episode")}
                  >
                    View Episode Data
                  </li>
                    </Link> */}

                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt/patient-admission/manage-admission/view-patient-journal"
                    style={{
                      textDecoration: "none",
                      marginLeft: "3vw",
                      marginRight: "3vw",
                    }}
                  >
                    <li
                      className={`nav-link ${activeTab == "journal" ? "active" : ""
                        }`}
                      //className="nav-link"
                      id="patientJournal"
                      style={{ marginRight: "15px" }}
                      onClick={() => this.props.onActiveClick("journal")}
                    >
                      View Journal Entry
                    </li>
                  </Link>
                  <Link
                    className="nav-item"
                    data-toggle="tab"
                    to="/projectmgmt/patient-admission/manage-admission/patient-app-usage"
                    style={{
                      textDecoration: "none",
                      marginLeft: "3vw",
                      marginRight: "3vw",
                    }}
                  >
                    <li
                      className={`nav-link ${activeTab == "appUsage" ? "active" : ""
                        }`}
                      id="patientAppUsage"
                      style={{ marginRight: "15px" }}
                      onClick={() => this.props.onActiveClick("appUsage")}
                    >
                      MyJeeva Patient App Usage
                    </li>
                  </Link>



                  {/* <Link
                  className="nav-item"
                  data-toggle="tab"
                  to="/projectmgmt/patient-admission/manage-admission/view-patient-survey"
                  style={{
                    textDecoration: "none",
                    marginLeft: "3vw",
                    marginRight: "3vw",
                  }}
                >
                  <li
                    className={`nav-link ${activeTab == "survey" ? "active" : ""
                      }`}
                    // className="nav-link"
                    id="viewSurvey"
                    style={{ marginRight: "15px" }}
                    onClick={() => this.props.onActiveClick("survey")}
                  >
                    View Survey
                  </li>
                </Link> */}

                  {/* <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/patient-admission/manage-admission/medication-list" style={{ textDecoration: 'none', marginLeft: '3vw', marginRight: '3vw' }}>
                  <li
                    // className="nav-link"
                    className={`nav-link ${activeTab == "medication" ? "active" : ""
                      }`}
                    id="medication-list"
                    style={{ marginRight: '15px' }}
                    onClick={() => this.props.onActiveClick("medication")}>
                    Medication List
                    </li></Link> */}
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/view-patient-journal"
              component={PatientJournal}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/view-patient-journal-result/"
              component={PatientJournalResult}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/view-patient-survey"
              component={PatientSurvey}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/view-patient-survey-result"
              component={PatientSuveryResult}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/provider-advice"
              component={ProviderAdvice}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/days-of-week"
              component={MedicationDaysOfWeek}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/view-patient-data"
              component={ViewPatientData}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/medication-list"
              component={PatientMedication}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/time-of-day"
              component={MedicationTimeOfDay}
            ></Route>

            <Route
              path="/projectmgmt/patient-admission/manage-admission/episode"
              component={Episode}
            ></Route>
            <Route
              path="/projectmgmt/patient-admission/manage-admission/patient-app-usage"
              component={PatientAppUsage}
            ></Route>
            <Route
              exact path="/projectmgmt/patient-admission/manage-admission"
              component={ScheduleMileStone}
            ></Route>

          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}
export default ManageTabSettings;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ManageTabSettings.js